"use client";

import Image from "next/image";
import { useState } from "react";

type SocialIconProps = {
  src: string;
  label: string;
};

/**
 * Renders a social-platform icon with a graceful text fallback.
 * If the icon file at `src` fails to load (e.g. no SVG exists for
 * the platform yet), the component falls back to the platform label.
 */
export function SocialIcon({ src, label }: SocialIconProps) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return <>{label}</>;
  }

  return (
    <Image
      src={src}
      alt=""
      width={18}
      height={18}
      onError={() => setFailed(true)}
    />
  );
}
